import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDown } from 'lucide-react';
import { faqs } from '../data/faqs';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 px-4 bg-white" data-id="element-94" data-mp="1hdupklvgf9bb">
      <div className="max-w-3xl mx-auto" data-id="element-95" data-mp="1cf03nb26x4mz">
        <div className="text-center mb-16" data-id="element-96" data-mp="1cgb8le7dgifo">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight text-neutral-900 uppercase" data-id="element-97" data-mp="2a1ytb1ugtcbd">
            Frequently Asked Questions
          </h2>
        </div>
        <div className="space-y-4" data-id="element-98" data-mp="2512pspe0zs6h">
          {faqs.map((faq, index) => <div key={faq.q} className="bg-neutral-100 border border-neutral-200 rounded-xl overflow-hidden" data-id="element-99" data-mp="202hoemn1f2gg" data-mpi={index}>
              <button type="button" className="w-full px-6 py-5 text-left flex items-center justify-between focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-red-700" onClick={() => setOpenIndex(openIndex === index ? null : index)} aria-expanded={openIndex === index} data-id="element-100" data-mp="oonr1mw02jq2">
                <span className="font-bold text-lg text-neutral-900 pr-8" data-id="element-101" data-mp="1apkid4ut8jzo">{faq.q}</span>
                <ChevronDown className={`text-red-700 transition-transform duration-200 ease-out shrink-0 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-102" data-mp="1arn9js7p8j5z" />
              </button>
              <AnimatePresence initial={false} data-id="element-103" data-mp="16o7ev1f6wsvx">
                {openIndex === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-104" data-mp="rzud1ntf8fti">
                    <div className="px-6 pb-5 text-neutral-800/80 border-t border-neutral-200 pt-4 space-y-2" data-id="element-105" data-mp="n22lww0loxqd">
                      {faq.a.map(paragraph => <p key={paragraph} data-id="element-106" data-mp="2kuvlo73qysk1">{paragraph}</p>)}
                      {faq.list && <ul className="list-disc pl-5 grid sm:grid-cols-2 gap-x-4 gap-y-1" data-id="element-107" data-mp="2fxd8g4ip5r68">
                          {faq.list.map(item => <li key={item} data-id="element-108" data-mp="38l93z5wj5d1f">{item}</li>)}
                        </ul>}
                      {faq.afterList && <p data-id="element-109" data-mp="33mxuwxe276k9">{faq.afterList}</p>}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}